import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChartPie = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M34.0297 18.8703H22.2855C21.1044 18.8703 20.1502 17.9161 20.1502 16.735V4.9908C20.1502 3.8097 21.1111 2.84214 22.2788 2.99562C29.4188 3.94316 35.0773 9.60174 36.0249 16.7417C36.1784 17.9094 35.2108 18.8703 34.0297 18.8703ZM14.6918 5.33779C15.8996 5.08422 16.9472 6.0718 16.9472 7.30628V20.4718C16.9472 20.8455 17.0807 21.2058 17.3142 21.4928L26.129 32.1293C26.9098 33.0702 26.7429 34.4915 25.6686 35.072C23.3932 36.3132 20.7841 37.0205 18.0149 37.0205C9.17332 37.0205 2 29.8472 2 21.0057C2 13.2985 7.43838 6.86587 14.6918 5.33779ZM31.7209 22.0733H35.9915C37.226 22.0733 38.2136 23.1209 37.96 24.3287C37.2794 27.5584 35.6245 30.4277 33.3157 32.6164C32.4949 33.3971 31.2071 33.2303 30.4864 32.3562L24.8545 25.5699C23.7001 24.1753 24.6944 22.0733 26.496 22.0733H31.7142H31.7209Z",
		fill: "currentColor"
	})
});
export default SvgChartPie;
